import email from "../assets/img/email.png";
import mobile from "../assets/img/mobile.png";
import api from "../assets/img/api.png";
import cpp from "../assets/img/cpp.png";
import css from "../assets/img/css.png";
import figma from "../assets/img/figma.png";
import git from "../assets/img/git.png";
import graphql from "../assets/img/graphql.png";
import html from "../assets/img/html.png";
import javascript from "../assets/img/javascript.png";
import mu5 from "../assets/img/mu5.png";
import node from "../assets/img/node.png";
import react from "../assets/img/react.png";
import redux from "../assets/img/redux.png";
import sass from "../assets/img/sass.png";
import typescript from "../assets/img/typescript.png";
import vue from "../assets/img/vue.png";
import bootstrap from "../assets/img/bootstrap.png";
import php from "../assets/img/php.png";
import tailwind from "../assets/img/tailwindcss-icon.svg";
import next from "../assets/img/nextjs.png";
import aws from "../assets/img/aws.png";
import terminal from "../assets/img/Terminal.png";
import mysql from "../assets/img/mysql.png";
import firebase from "../assets/img/firebase.png";

import about01 from "../assets/img/about01.png";
import about02 from "../assets/img/about02.png";
import about03 from "../assets/img/about03.png";
import about04 from "../assets/img/about04.png";

import profile from "../assets/img/profile.png";
import circle from "../assets/img/circle.svg";

// eslint-disable-next-line
export default {
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  react,
  redux,
  sass,
  typescript,
  vue,
  bootstrap,
  tailwind,
  terminal,
  mysql,
  firebase,
  php,
  next,
  aws,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
};
